import * as mathUtil from '@/common/js/mathutil.js'

import Decimal from '@/math/types/decimal.js'
import Fraction from '@/math/types/fraction.js'
import Relation from '@/math/types/relation.js'

export default {
  title: 'Convert decimals to mixed numbers',
  operation: 'convert-rational',
  instruction: 'Convert to a mixed number and simplify.',
  config: { nProblems: 10, maxPlaces: 7, lhsType: 'decimal', rhsType: 'mixed' },
  relation: function () {
    var whole = mathUtil.randomIntUniform(1, 9)
    var denominator = Math.pow(10, 3)

    var factor = mathUtil.randomFactorOf(denominator, 2, denominator - 1)
    var numerator = factor * mathUtil.randomIntUniform(1, 99)
    while (numerator >= denominator) {
      factor = mathUtil.randomFactorOf(denominator, 2, denominator - 1)
      numerator = factor * mathUtil.randomIntUniform(1, 99)
    }

    var lhs = new Decimal(numerator).div(denominator).add(whole)
    var rhs = new Fraction(whole, numerator, denominator).simplify()

    return new Relation('=', lhs, rhs)
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/dec/decptzr.js